var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"avatar",attrs:{"text":_vm.initials,"title":`Angemeldet als ${_vm.user.username}`}},[_c('b-dropdown-item',{on:{"click":function($event){return _vm.$router.push({ name: 'PasswordReset' })}}},[_vm._v("Passwort ändern")]),_c('b-dropdown-item',{on:{"click":_vm.onLogout}},[_vm._v("Abmelden")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }